import React from 'react';
import {FormattedMessage} from 'react-intl';

class ResolutionNotSupportedComponent extends React.Component {
   render() {
      return (
         <div>
            <h1>{<FormattedMessage id="unsupportedResolutionPage.message1"/>}</h1>
            <br/>
            <h1>{<FormattedMessage id="unsupportedResolutionPage.message2"/>}</h1>
         </div>
      );
   }
}

export default ResolutionNotSupportedComponent;


// WEBPACK FOOTER //
// ./src/components/resolutionNotSupported.component.js